import React from "react";
import PropTypes from "prop-types";
import { Transition } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../../components/layout/V2/Layout";
import AddCategory from "./addCategory";
import { useProductPhotosContext } from "../../../utils/Contexts/V2/ProductPhotosContext";

function Category({ category, selectCategoryHandler }) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const photoID = queryParams.get("id");

  return (
    <button
      onClick={() => {
        selectCategoryHandler(category);
        navigate(
          photoID
            ? `/edit-photos?id=${photoID}&category=${category.id}`
            : `/add-photos`
        );
      }}
      key={category.id}
      className="w-[9.8125rem] h-[10.875rem] shrink-0 overflow-hidden flex flex-col items-center border-[1px] border-[#E7E7E7] rounded-[0.5rem]"
      type="button"
    >
      <div className="bg-[#F8F6FB] w-full h-[7.1875rem] flex justify-center items-center">
        <svg
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.375 18.75H45V22.5H54.375V33.75H41.25V37.5H46.875V41.5163C45.1075 41.9726 43.5671 43.0579 42.5426 44.5688C41.5181 46.0796 41.0798 47.9122 41.3098 49.7231C41.5398 51.534 42.4224 53.1989 43.7921 54.4056C45.1618 55.6123 46.9245 56.2781 48.75 56.2781C50.5755 56.2781 52.3382 55.6123 53.7079 54.4056C55.0776 53.1989 55.9602 51.534 56.1902 49.7231C56.4202 47.9122 55.9819 46.0796 54.9574 44.5688C53.9329 43.0579 52.3925 41.9726 50.625 41.5163V37.5H54.375C55.3691 37.4985 56.3221 37.1029 57.025 36.4C57.7279 35.6971 58.1235 34.7441 58.125 33.75V22.5C58.124 21.5057 57.7286 20.5525 57.0256 19.8494C56.3225 19.1464 55.3693 18.751 54.375 18.75ZM52.5 48.75C52.5 49.4917 52.2801 50.2167 51.868 50.8334C51.456 51.4501 50.8703 51.9307 50.1851 52.2146C49.4998 52.4984 48.7458 52.5726 48.0184 52.4279C47.291 52.2832 46.6228 51.9261 46.0984 51.4016C45.5739 50.8772 45.2168 50.209 45.0721 49.4816C44.9274 48.7542 45.0016 48.0002 45.2854 47.3149C45.5693 46.6297 46.0499 46.044 46.6666 45.632C47.2833 45.2199 48.0083 45 48.75 45C49.7441 45.0015 50.6971 45.3971 51.4 46.1C52.1029 46.8029 52.4985 47.7559 52.5 48.75ZM35.625 11.25H26.25V15H35.625V26.25H22.5V30H28.125V41.5163C26.3575 41.9726 24.8171 43.0579 23.7926 44.5688C22.7681 46.0796 22.3298 47.9122 22.5598 49.7231C22.7898 51.534 23.6724 53.1989 25.0421 54.4056C26.4118 55.6123 28.1745 56.2781 30 56.2781C31.8255 56.2781 33.5882 55.6123 34.9579 54.4056C36.3276 53.1989 37.2102 51.534 37.4402 49.7231C37.6702 47.9122 37.2319 46.0796 36.2074 44.5688C35.1829 43.0579 33.6425 41.9726 31.875 41.5163V30H35.625C36.6193 29.999 37.5725 29.6036 38.2756 28.9006C38.9786 28.1975 39.374 27.2443 39.375 26.25V15C39.374 14.0057 38.9786 13.0525 38.2756 12.3494C37.5725 11.6464 36.6193 11.251 35.625 11.25ZM33.75 48.75C33.75 49.4917 33.5301 50.2167 33.118 50.8334C32.706 51.4501 32.1203 51.9307 31.4351 52.2146C30.7498 52.4984 29.9958 52.5726 29.2684 52.4279C28.541 52.2832 27.8728 51.9261 27.3484 51.4016C26.8239 50.8772 26.4667 50.209 26.3221 49.4816C26.1774 48.7542 26.2516 48.0002 26.5355 47.3149C26.8193 46.6297 27.2999 46.044 27.9166 45.632C28.5333 45.2199 29.2583 45 30 45C30.9941 45.0015 31.9471 45.3971 32.65 46.1C33.3529 46.8029 33.7485 47.7559 33.75 48.75ZM16.875 3.75H5.625C4.63074 3.75099 3.67749 4.1464 2.97445 4.84945C2.2714 5.55249 1.87599 6.50574 1.875 7.5V18.75C1.87599 19.7443 2.2714 20.6975 2.97445 21.4006C3.67749 22.1036 4.63074 22.499 5.625 22.5H9.375V41.5163C7.60752 41.9726 6.06714 43.0579 5.04262 44.5688C4.0181 46.0796 3.57976 47.9122 3.80978 49.7231C4.03979 51.534 4.92237 53.1989 6.29206 54.4056C7.66176 55.6123 9.42455 56.2781 11.25 56.2781C13.0755 56.2781 14.8382 55.6123 16.2079 54.4056C17.5776 53.1989 18.4602 51.534 18.6902 49.7231C18.9202 47.9122 18.4819 46.0796 17.4574 44.5688C16.4329 43.0579 14.8925 41.9726 13.125 41.5163V22.5H16.875C17.8693 22.499 18.8225 22.1036 19.5256 21.4006C20.2286 20.6975 20.624 19.7443 20.625 18.75V7.5C20.624 6.50574 20.2286 5.55249 19.5256 4.84945C18.8225 4.1464 17.8693 3.75099 16.875 3.75ZM15 48.75C15 49.4917 14.7801 50.2167 14.368 50.8334C13.956 51.4501 13.3703 51.9307 12.6851 52.2146C11.9998 52.4984 11.2458 52.5726 10.5184 52.4279C9.79098 52.2832 9.1228 51.9261 8.59835 51.4016C8.0739 50.8772 7.71675 50.209 7.57205 49.4816C7.42736 48.7542 7.50162 48.0002 7.78545 47.3149C8.06928 46.6297 8.54993 46.044 9.16661 45.632C9.7833 45.2199 10.5083 45 11.25 45C12.2443 45.001 13.1975 45.3964 13.9006 46.0994C14.6036 46.8025 14.999 47.7557 15 48.75ZM5.625 18.75V7.5H16.875L16.8787 18.75H5.625Z"
            fill="#A298B3"
          />
        </svg>
      </div>
      <p className="text-[#1C1F34] text-[0.875rem] font-semibold h-[3rem] w-full flex justify-center items-center">
        {category.category_name}
      </p>
    </button>
  );
}

Category.propTypes = {
  category: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  selectCategoryHandler: PropTypes.func.isRequired,
};

function PhotoCategory() {
  const {
    selectCategoryHandler,
    productCategories,
    showAddCategoryPrompt,
    setShowAddCategoryPrompt,
  } = useProductPhotosContext();

  return (
    <Layout header headerTitle="Category">
      <Transition
        className="fixed -bottom-12 left-0 z-20 w-full"
        show={showAddCategoryPrompt}
        enterFrom=" translate-y-0"
        enterTo=" -translate-y-12"
        leaveFrom=" -translate-y-12"
        leaveTo=" translate-y-0"
      >
        <AddCategory />
      </Transition>
      <div className="relative w-full md:max-w-screen-md  h-[100vh] scroll-smooth pt-20 flex flex-col justify-start items-center overflow-hidden px-4">
        <p className="text-[#1A1A1A] text-[0.875rem] font-bold">
          You have {productCategories?.length || 0} categories
        </p>
        <div className="flex flex-row flex-wrap items-center justify-evenly md:justify-start gap-4 w-full h-fit pb-28 pt-6 overflow-y-scroll">
          <button
            onClick={() => setShowAddCategoryPrompt(true)}
            className="w-[9.8125rem] h-[10.875rem] shrink-0 flex flex-col justify-center items-center border-[1px] border-[#E7E7E7] rounded-[0.5rem] text-[#1C1F34] text-[1.25rem] font-semibold"
            type="button"
          >
            <p>+</p>
            <p>Add New</p>
          </button>
          {productCategories
            ?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at))
            ?.map((cat) => (
              <Category
                category={cat}
                selectCategoryHandler={selectCategoryHandler}
              />
            ))}
        </div>
      </div>
    </Layout>
  );
}

export default PhotoCategory;
